export default function UploadPlusIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="60"
        height="60"
        x="0"
        y="0"
        viewBox="0 0 512 512"
      >
        <g>
          <path
            d="M43.9 373.285h6.527v5.572c0 20.899 17.002 37.901 37.901 37.901H283.06a5.724 5.724 0 0 0 5.725-5.725 5.724 5.724 0 0 0-5.725-5.725H88.328c-14.585 0-26.451-11.866-26.451-26.451V101.874c0-14.585 11.866-26.451 26.451-26.451h281.451c14.583 0 26.449 11.866 26.449 26.451v164.351a5.724 5.724 0 0 0 5.725 5.725 5.724 5.724 0 0 0 5.725-5.725V101.874c0-20.899-17.002-37.901-37.9-37.901h-6.528v-5.61c0-20.877-17.002-37.862-37.9-37.862H43.9C23.002 20.5 6 37.486 6 58.363v277.023c0 20.897 17.002 37.899 37.9 37.899zM17.45 58.363c0-14.563 11.866-26.412 26.449-26.412H325.35c14.583 0 26.449 11.849 26.449 26.412v5.61H88.328c-20.899 0-37.901 17.002-37.901 37.901v259.961H43.9c-14.583 0-26.449-11.866-26.449-26.449V58.363z"
            fill="#000000"
            opacity="0.5"
            data-original="#000000"
          ></path>
          <path
            d="M370.351 276.149a5.724 5.724 0 0 0 5.725-5.725V114.737c0-10.998-8.79-20.573-20.573-20.573h-252.9c-11.344 0-20.573 9.229-20.573 20.573v210.419c1.617 16.515 3.544 26.319 20.245 27.28.108.005.216.009.323.009H287.755a5.724 5.724 0 0 0 5.725-5.725 5.724 5.724 0 0 0-5.725-5.725l-184.824.009c-11.984-.687-8.978-12.528-9.451-13.786l79.066-95.433c11.395-13.76 32.268-13.445 43.338-.129l58.484 69.82c3.841 4.56 10.692 5.19 15.239 1.444l28.313-22.973c2.969-2.4 6.733-3.724 10.599-3.724 5.146 0 10.069 2.404 13.139 6.389l.345.457a5.726 5.726 0 0 0 9.139-6.899l-.38-.501c-5.256-6.823-13.571-10.895-22.243-10.895-6.478 0-12.8 2.227-17.805 6.277l-27.92 22.653-58.119-69.384c-15.533-18.685-44.884-19.229-60.948.16L93.48 309.27V114.737c0-5.03 4.093-9.123 9.123-9.123h252.9c5.089 0 9.123 4.133 9.123 9.123v155.687a5.724 5.724 0 0 0 5.725 5.725z"
            fill="#000000"
            opacity="0.5"
            data-original="#000000"
          ></path>
          <path
            d="M266.574 170.091c0 16.997 13.827 30.823 30.823 30.823 16.997 0 30.823-13.827 30.823-30.823s-13.827-30.823-30.823-30.823-30.823 13.827-30.823 30.823zm50.197 0c0 10.683-8.69 19.373-19.373 19.373s-19.373-8.69-19.373-19.373 8.69-19.373 19.373-19.373 19.373 8.691 19.373 19.373zM401.951 283.401c-57.373 0-104.05 46.677-104.05 104.05S344.578 491.5 401.951 491.5 506 444.824 506 387.451s-46.676-104.05-104.049-104.05zm0 196.648c-51.061 0-92.6-41.539-92.6-92.598 0-51.061 41.539-92.6 92.6-92.6 51.059 0 92.598 41.539 92.598 92.6.001 51.059-41.539 92.598-92.598 92.598z"
            fill="#000000"
            opacity="0.5"
            data-original="#000000"
          ></path>
          <path
            d="M451.324 365.374h-27.297v-27.297c0-29.22-44.152-29.18-44.152 0v27.297h-27.297c-29.215 0-29.197 44.152 0 44.152h27.297v27.297c0 29.232 44.152 29.183 44.152 0v-27.297h27.297c29.186 0 29.194-44.152 0-44.152zm0 32.702h-33.022a5.724 5.724 0 0 0-5.725 5.725v33.022c0 14.062-21.251 14.047-21.251 0v-33.022a5.724 5.724 0 0 0-5.725-5.725h-33.022c-14.059 0-14.051-21.251 0-21.251H385.6a5.724 5.724 0 0 0 5.725-5.725v-33.022c0-14.059 21.251-14.047 21.251 0V371.1a5.724 5.724 0 0 0 5.725 5.725h33.022c14.083-.001 14.003 21.251.001 21.251z"
            fill="#000000"
            opacity="0.5"
            data-original="#000000"
          ></path>
        </g>
      </svg>
    </>
  );
}
